export default (t) => [
  {
    text: t('Option Name'),
    value: 'name'
  },
  {
    text: t('Price'),
    value: 'price'
  },
  {
    text: t('Default'),
    value: 'default'
  },
  {
    text: t('Recipes'),
    value: 'recipes'
  }
];
